import { Action, createReducer, on } from '@ngrx/store';
import { fromProductCurrenciesAction } from '../actions';
import { ErrorResponse, IGenericError } from '../../../../src/app/core/models/generic-models';
import { IStaticDataResponse } from '../models/static-data.model';

export const productCurrenciesFeatureKey = 'productCurrencies';

export interface ProductCurrenciesState {
  productCurrenciesResponse: IStaticDataResponse[];
  productCurrenciesFailure: IGenericError<ErrorResponse>;
  loaded: boolean;
}

export const initialState: ProductCurrenciesState = {
  productCurrenciesFailure: undefined,
  productCurrenciesResponse: undefined,
  loaded: undefined
};

export const reducer = createReducer(
  initialState,

  on(fromProductCurrenciesAction.loadProductCurrencies, (state, action) => ({
    ...state,
    loaded: true
  })),

  on(fromProductCurrenciesAction.loadProductCurrenciesSuccess, (state, action) => ({
    ...state,
    productCurrenciesResponse: action.response
  })),

  on(fromProductCurrenciesAction.loadProductCurrenciesFailure, (state, action) => ({
    ...state,
    productCurrenciesFailure: action.error
  }))
);

export const getProductCurrenciesResponse = (state: ProductCurrenciesState) => state.productCurrenciesResponse;
export const getProductCurrenciesFailure = (state: ProductCurrenciesState) => state.productCurrenciesFailure;
export const getProductCurrenciesIsLoaded = (state: ProductCurrenciesState) => state.loaded;
